/**
 * Helpers de copy para slugs de membresía expuestos por el backend.
 *
 * ROUND19 #11 — Centralizado para que cualquier surface que muestre
 * `subscription_plans.slug` (o el campo derivado `membership_required` en
 * flash sales) lo traduzca a copy legible en español.
 *
 * Convenciones:
 *   - 'first_class' / 'firstclass' → "FirstClass"
 *   - 'free'                       → "Free"
 *   - slug desconocido             → title-case (`vip_gold` → "Vip Gold")
 */

const KNOWN_LABELS: Record<string, string> = {
  first_class: 'FirstClass',
  firstclass: 'FirstClass',
  free: 'Free',
};

/** Devuelve el label legible para un slug de plan. Defensivo ante input vacío. */
export function membershipPlanLabel(slug: string | null | undefined): string {
  if (!slug) return '';
  const key = slug.trim().toLowerCase();
  if (KNOWN_LABELS[key]) return KNOWN_LABELS[key];
  return key
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}
